<nav class="navbar">
  <a href="" class="sidebar-toggler" (click)="toggleSidebar($event)">
    <mat-icon svgIcon="icon-menu"></mat-icon>
  </a>
  <div class="navbar-content">
    <!--<form class="search-form">
      <div class="input-group">
        <div class="input-group-text">
        </div>
        <input type="text" class="form-control" id="navbarForm" placeholder="Søg her">
      </div>
    </form>-->
    <ng-container *ngIf="coreConfig.dominoConfig.whitelabel.topbarannouncement">
      <div class="my-auto">
          <a class="announcement"
             (click)="showAnnouncement()"
                [style.color]="'#' + coreConfig.dominoConfig.whitelabel.topbarannouncementcolor">
            {{  coreConfig.dominoConfig.whitelabel.topbarannouncement }}
          </a>
      </div>
    </ng-container>
    <ul class="navbar-nav">

      <li class="nav-item" *ngIf=" ! profileStateService.isLoggedIn()">
          <a routerLink="/auth/login" class="text-nowrap">
            <span style="vertical-align: text-bottom">Log ind</span>
            <i class="mdi mdi-login fs-2 ms-2"></i>
          </a>
      </li>
      <ng-container *ngIf="profileStateService.isLoggedIn()">
        <li class="nav-item nav-profile" ngbDropdown *ngIf="coreConfig.dominoConfig.usesearchprofilemulti">
          <a class="nav-link d-flex align-items-center" ngbDropdownToggle id="profileDropdown">
            <span class="d-none d-md-block mb-2px me-1 text-end">
              {{ this.profileStateService.profile()?.firstname }} {{ this.profileStateService.profile()?.lastname }}
              <br>
              <app-organisation-name [id]="profileStateService.profile()?.level?.defaultFull" [showPath]="true"></app-organisation-name>
            </span>
            <i class="mdi mdi-chevron-down fs-2 mt-md-4"></i>
          </a>
          <div ngbDropdownMenu class="px-0" aria-labelledby="profileDropdown">
            <ul class="list-unstyled p-1">
              <li *ngFor="let level of profileStateService.profile()?.levelPresets"
                  [class.active]="level === profileStateService.profile()?.level?.defaultFull"
                  class="dropdown-item">
                <a href="" (click)="changeSearchLevel(level, $event)"
                   [class.text-white]="level === profileStateService.profile()?.level?.defaultFull"
                   [class.text-body]="level !== profileStateService.profile()?.level?.defaultFull"
                   class="d-flex ms-0 align-items-center py-1">
                  <span>
                    <app-organisation-name [id]="level" [showPath]="true" />
                    <span *ngIf="level === profileStateService.profile()?.level?.defaultFull">(aktiv)</span>
                  </span>
                </a>
              </li>
              <li *ngIf="(profileStateService.profile()?.levelPresets?.length ?? 0) > 0"
                class="dropdown-item">
                <hr class="dropdown-divider">
              </li>
              <li class="dropdown-item">
                <a (click)="openProfilModal()"
                   class="d-flex ms-0 align-items-center py-1 text-body">
                  <span>
                    <i class="mdi mdi-pencil"></i>
                    Rediger profil
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </li>
        <li class="nav-item nav-profile" ngbDropdown #profileDropdownMenu="ngbDropdown" [autoClose]="true" (mouseenter)="profileDropdownMenu.open()">
          <a class="nav-link" ngbDropdownToggle id="profileDropdown">
            <mat-icon svgIcon="icon-user-filled" class="text-success"></mat-icon>
          </a>
          <div ngbDropdownMenu class="px-0" aria-labelledby="profileDropdown">
            <div class="d-flex flex-column align-items-center border-bottom px-5 py-3">
              <div class="text-center">
                <p class="tx-16 fw-bolder">{{ this.profileStateService.profile()?.firstname }} {{ this.profileStateService.profile()?.lastname }}</p>
              </div>
            </div>
            <ul class="list-unstyled p-1">
              <li class="dropdown-item">
                <a (click)="openProfilModal()" class="d-flex text-body ms-0  align-items-center  py-1">
                  <mat-icon svgIcon="icon-user" class="me-2"></mat-icon>
                  <span>Min profil</span>
                </a>
              </li>
              <li class="dropdown-item">
                <a href="" (click)="onLogout($event)" class="d-flex text-body ms-0 align-items-center py-1">
                  <i class="mdi mdi-logout me-2 ms-2 fs-4"></i>
                  <span>Log ud</span>
                </a>
              </li>
              <li class="dropdown-item py-2">
                <a (click)="showVersionInfo()" class="d-flex text-body ms-0 align-items-center">
                  <mat-icon svgIcon="icon-info" class="me-2"></mat-icon>
                  <span>Systeminformation</span>
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ng-container>
    </ul>
  </div>
</nav>
